import lodash from 'lodash';
import moment from 'moment';

const PI_ROLE = 'Principal Investigator';

export function isPITenureOverlappingWithDelegation(piTenure, delegationTenure) {
    const [piStart, piEnd] = piTenure;
    const [delegationStart, delegationEnd] = delegationTenure;

    if (lodash.isNil(piStart) || lodash.isNil(delegationStart)) {
        return false;
    }

    if (
        !lodash.isNil(piEnd) &&
        !lodash.isNil(delegationStart) &&
        moment(piEnd).isSameOrBefore(delegationStart)
    ) {
        return false;
    }

    if (
        !lodash.isNil(piStart) &&
        !lodash.isNil(delegationEnd) &&
        moment(piStart).isSameOrAfter(delegationEnd)
    ) {
        return false;
    }

    return true;
}

export const isActivePI = (piTenure, today) => {
    const [piStart, piEnd] = piTenure;
    if(lodash.isNil(piStart) || moment(piStart).isAfter(today)) {
        return false;
    }

    if(!lodash.isNil(piEnd) && moment(piEnd).isBefore(today)) {
        return false;
    }
    
    return true;
};

export const isDelegationTheSameWithDefault = (defaultDelegation, newDelegation) => {
    const fieldsNeedCompare = ['delegatedTasks', 'delegationRole', 'startDate', 'endDate'];

    for (let index = 0; index < fieldsNeedCompare.length; index++) {
        const item = fieldsNeedCompare[index];

        if (!lodash.isEqual(defaultDelegation[item], newDelegation[item])) {
            return false;
        }
    }
    return true;
};

export function delegationsUnderPITenurePredicate(delegations, tenureStartEnd) {
    const [tenureStart, tenureEnd] = tenureStartEnd;
    return lodash.filter(
        delegations,
        ({ role, tasks, startDate, endDate }) =>
            !lodash.isNil(role) &&
            !lodash.isEmpty(tasks) &&
            !lodash.isNil(startDate) &&
            lodash.get(role, 'name') !== PI_ROLE &&
            isPITenureOverlappingWithDelegation([tenureStart, tenureEnd], [startDate, endDate])
    );
}

// Signature should appear when we dont have deletedSignature before or completedSignatureLength < deletedSignatureLength
export const isSignatureShouldAppear = (user) => {
    const latestSignature = user.signatures[0];

    if (latestSignature) {
        if (latestSignature.signatureStatus === 'COMPLETED') return false;
    }
    return true;
};

export const shouldUserInDropDownSignature = (allSignatures, signatures) => {
    const descSignatures = signatures.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    const allSignByIds = allSignatures.map((item) => item.value);
    const sigSignById = signatures.map((item) => item.signBy);

    const chainSignatures = lodash
        .chain(descSignatures)
        .groupBy('signBy')
        .map((value, key) => ({
            signBy: key,
            signatures: value,
        }))
        .value();

    const differenceIds = lodash.difference(allSignByIds, sigSignById);
    const result = chainSignatures
        .filter((item) => isSignatureShouldAppear(item))
        .map((item) => item.signBy);

    return [...result, ...differenceIds];
};
